export enum KycType {
    PhysicalCard = 1
}

export enum KycValidationType
{
    IdentityDocument = 1,
    FacePicture = 2,
    Address = 3,
    Email = 4,
    Phone = 5,
    OpeningDate = 6
}


export enum KycStatus
{
    AwaitingValidation = 1, //Aguardando validação (Enviado)
    InValidation = 2, //Em validação
    AwaitingRevalidation = 3, //Aguardando reavaliação
    Rejected = 4, //Rejeitado
    Approved = 5,  //Aprovado
    CanceledByUser = 6 //Cancelado pelo usuário
}
